import { SampleSendType } from "utils/constant";

export const SAD = SampleSendType.SAD;

// Bila ada jenis sampel yang dicentang, tanggal kirim bersama wajib diisi.
export const sampleSendDateErrors = (values = {}) => {
  const types = Array.isArray(values.sample_send_type)
    ? values.sample_send_type.filter(Boolean)
    : [];
  if (types.length === 0) return {};
  return values.sample_send_date
    ? {}
    : { sample_send_date: "Tanggal kirim sampel wajib diisi" };
};

// Tanggal kirim awal untuk modal: prioritaskan jenis sampel yang dicentang
// (SAD, lalu DBS, lalu WB); fallback ke tanggal kirim pertama yang terisi untuk data lama.
export const initialSendDate = (row = {}) => {
  const types = Array.isArray(row.sample_send_type)
    ? row.sample_send_type.filter(Boolean)
    : [];
  const byType = [
    [SampleSendType.SAD, row.sample_sad_send_date],
    [SampleSendType.DBS, row.sample_dbs_send_date],
    [SampleSendType.WB, row.sample_wb_send_date],
  ];
  const checkedDate = byType.find(
    ([type, date]) => types.includes(type) && date
  );
  if (checkedDate) return checkedDate[1];
  if (types.length > 0) return null;
  return byType.map(([, date]) => date).find(Boolean) || null;
};

// Petakan tanggal kirim bersama ke kolom per jenis: hanya jenis yang dicentang
// yang mendapat tanggal; lainnya null.
export const sampleSendDates = ({
  sample_send_type = [],
  sample_send_date,
} = {}) => {
  const types = Array.isArray(sample_send_type)
    ? sample_send_type.filter(Boolean)
    : [];
  const date = sample_send_date || null;
  return {
    sample_sad_send_date: types.includes(SampleSendType.SAD) ? date : null,
    sample_dbs_send_date: types.includes(SampleSendType.DBS) ? date : null,
    sample_wb_send_date: types.includes(SampleSendType.WB) ? date : null,
  };
};

// Minimal satu jenis sampel harus dipilih agar data bisa disimpan.
export const sampleTypeError = (sampleSendType) => {
  const types = Array.isArray(sampleSendType)
    ? sampleSendType.filter(Boolean)
    : [];
  return types.length > 0
    ? null
    : "Pilih minimal salah satu jenis sampel (SAD, DBS, atau WB)";
};
